import styled from 'styled-components';
import {
    color,
    space,
    layout,
    flexbox,
    grid,
    background,
    border,
    position,
    shadow,
} from 'styled-system';

export const Box = styled('div')(
    color,
    space,
    layout,
    flexbox,
    grid,
    background,
    border,
    position,
    shadow,
);